module.exports = __webpack_public_path__ + "img/purchase_banner3.00a78634.png";